import { usePwaUpdate } from "@/contexts/PwaUpdateContext";
import { useOptionalManuscriptContext } from "@/contexts/ManuscriptContext";
import { isAndroidPlatform } from "@/utils/platform";

export function ReloadPrompt() {
  const manuscriptContext = useOptionalManuscriptContext();
  const { needRefresh, updateApp, dismissUpdate } = usePwaUpdate();

  if (isAndroidPlatform() || !needRefresh) return null;

  const handleUpdate = async () => {
    // Guarantee manuscript data is flushed to IndexedDB before the hard refresh
    if (manuscriptContext?.triggerEditorSave) {
      await manuscriptContext.triggerEditorSave();
    }
    await updateApp();
  };


  // E-ink compliant: no animations, pure high contrast, no scrolling, explicit manual dismissal
  return (
    <div className="fixed bottom-6 right-6 z-[9999] p-6 border-4 border-foreground bg-background text-foreground w-[360px] max-w-[calc(100vw-3rem)]">
      <h3 className="mb-2 font-serif font-bold text-xl uppercase tracking-wider">
        Update Available
      </h3>
      <p className="mb-6 font-serif text-base leading-relaxed">
        A new version of Birch is ready. Your work has been safely saved.
      </p>
      <div className="flex gap-4">
        <button
          onClick={handleUpdate}
          className="flex-1 h-12 border-2 border-foreground bg-foreground text-background font-bold font-serif focus:outline-none"
        >
          Update Now
        </button>
        <button
          onClick={dismissUpdate}
          className="flex-1 h-12 border-2 border-foreground bg-background text-foreground font-bold font-serif focus:outline-none"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}